'use strict';

const { h } = require('phy');

function adjustLazyLoad(value) {
  const response =
    value &&
    value.replace(/<img(.+?)>/g, match => {
      if (match.includes('lazyload')) {
        return match
          .replace(/lazyload/gi, 'lazy-load no-bg')
          .replace(/ src=".+?"/gi, ' src=""');
      } else {
        return match;
      }
    });
  return response || '';
}

function RichContent({ data }) {
  let { richContent } = data || {};
  richContent = adjustLazyLoad(richContent);

  return (
    richContent &&
    h('.rich-content', { dangerouslySetInnerHTML: { __html: richContent } })
  );
}

module.exports = RichContent;
